export enum PartBomType {
  ATO = 'ATO',
  PTO = 'PTO',
  STANDARD = 'standard',
}
